import { render, staticRenderFns } from "./QuotationProjectsTable.vue?vue&type=template&id=aa6cd80e&scoped=true"
import script from "./QuotationProjectsTable.vue?vue&type=script&lang=js"
export * from "./QuotationProjectsTable.vue?vue&type=script&lang=js"
import style0 from "./QuotationProjectsTable.vue?vue&type=style&index=0&id=aa6cd80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6cd80e",
  null
  
)

export default component.exports